// Greens
export const g500 = '#004c4c';
export const g400 = '#005e5d';
export const g300 = '#00716b';
export const g200 = '#00857a';
export const g100 = '#37aba1';
export const g75 = '#86d1cd';
export const g65 = '#ade0df';
export const g55 = '#d8f0ef';
export const g50 = '#edf7f7';

// Yellows
export const y500 = '#e6b400';
export const y400 = '#f3c000';
export const y300 = '#ffd200';
export const y200 = '#ffe263';
export const y100 = '#ffea8f';
export const y75 = '#fff2ba';
export const y65 = '#fff6cc';
export const y55 = '#fff9de';
export const y50 = '#fffbe6';

// Greens Muted
export const gm500 = '#2d4d4d';
export const gm400 = '#3c5e5e';
export const gm300 = '#4f706f';
export const gm200 = '#668582';
export const gm100 = '#91aba9';
export const gm75 = '#c0d1d0';
export const gm65 = '#d3e0e0';
export const gm55 = '#e9f0f0';
export const gm50 = '#f2f7f7';

// Naturals
export const n670 = '#222';
export const n500 = '#4d4d4d';
export const n400 = '#666';
export const n300 = '#808080';
export const n200 = '#999';
export const n100 = '#b3b3b3';
export const n75 = '#ccc';
export const n65 = '#dedede';
export const n55 = '#f0f0f0';
export const n50 = '#f9f9f9';
export const white = '#fff';

// ABN Positive
export const positive500 = '#4c7a12';
export const positive400 = '#608e28';
export const positive300 = '#78a343';
export const positive200 = '#94ba65';
export const positive100 = '#b0cf8a';
export const positive75 = '#d1e6b8';
export const positive65 = '#ddedcb';
export const positive55 = '#ebf5df';
export const positive50 = '#f2fae8';

// ABN Info
export const info500 = '#00a6e3';
export const info400 = '#00abe9';
export const info300 = '#2dbaed';
export const info200 = '#5acaf2';
export const info100 = '#89d8f5';
export const info75 = '#b9e9fa';
export const info65 = '#d1f0fc';
export const info55 = '#ebfaff';
export const info50 = '#edfaff';

// ABN Negative
export const negative500 = '#c21700';
export const negative400 = '#d21b02';
export const negative300 = '#db402c';
export const negative200 = '#e36959';
export const negative100 = '#ed9387';
export const negative75 = '#ffc9c2';
export const negative65 = '#ffdcd8';
export const negative55 = '#fff1f0';
export const negative50 = '#fff4f2';

// ABN Warning
export const warning500 = '#e65c00';
export const warning400 = '#f60';
export const warning300 = '#ff822e';
export const warning200 = '#ff9f5e';
export const warning100 = '#ffba8c';
export const warning75 = '#ffd7bd';
export const warning65 = '#ffe4d1';
export const warning55 = '#fff1e8';
export const warning50 = '#fff3eb';

// ABN Privacy
export const privacy500 = '#561391';
export const privacy400 = '#6927a3';
export const privacy300 = '#8145b5';
export const privacy200 = '#9a67c7';
export const privacy100 = '#ba93db';
export const privacy75 = '#d8c0ed';
export const privacy65 = '#e7d7f6';
export const privacy55 = '#f7f0ff';
export const privacy50 = '#f9f2ff';
